import { createFileRoute } from "@tanstack/react-router"
import { createLLMOMeta, createBreadcrumbSchema, createFAQSchema } from "@/lib/seo"
import { getUseCaseBySlug } from "@/data/use-cases/use-cases-registry"
import { getUseCaseBySlugForLanguage } from "@/data/use-cases/use-cases-i18n"
import { useTranslation } from "@/lib/i18n"
import UseCasePageLayout from "@/components/use-cases/UseCasePageLayout"

const data = getUseCaseBySlug("instagram-comment-dm-automation")!

export const Route = createFileRoute("/use-case/instagram-comment-dm-automation")({
  head: () => ({
    meta: [
      ...createLLMOMeta({
        title: data.seo.title,
        description: data.seo.description,
        url: "https://zapify.pro/use-case/instagram-comment-dm-automation",
      }),
      { name: "keywords", content: data.seo.keywords },
    ],
    links: [{ rel: "canonical", href: "https://zapify.pro/use-case/instagram-comment-dm-automation" }],
    scripts: [
      createBreadcrumbSchema({
        itemListElement: [
          { position: 1, name: "Home", item: "https://zapify.pro" },
          { position: 2, name: "Use Cases", item: "https://zapify.pro/use-case" },
          { position: 3, name: data.name, item: "https://zapify.pro/use-case/instagram-comment-dm-automation" },
        ],
      }),
      createFAQSchema(data.faqs),
    ],
  }),
  component: AutoRespondPage,
})

function AutoRespondPage() {
  const { language } = useTranslation()
  const localizedData = getUseCaseBySlugForLanguage(language, "instagram-comment-dm-automation") || data
  return <UseCasePageLayout data={localizedData} />
}
